import javaScript from "../../assets/javaScript.svg";
import typeScript from "../../assets/typeScript.svg";
import react from "../../assets/react.svg";
import redux from "../../assets/redux.svg";
import tailwind from "../../assets/tailwind.svg";
import shadcn from "../../assets/shadcn.webp";
import next from "../../assets/next.svg";
import headless from "../../assets/headless-ui.webp";
import antD from "../../assets/ant-design.webp";

export const Stacks = () => {
  const stacks = [
    { name: "React Js", src: react },
    { name: "Next Js", src: next },
    { name: "Redux", src: redux },
    { name: "Tailwind CSS", src: tailwind },
    { name: "AntD", src: antD },
    { name: "Shadcn UI", src: shadcn },
    { name: "Headless UI", src: headless },
    { name: "TypeScript", src: typeScript },
    { name: "JavaScript", src: javaScript },
  ];

  return (
    <div className="stacks-marquee">
      <div className="stacks-marquee__track">
        <div className="stacks-marquee__group">
          {stacks.map((stack) => {
            return (
              <div
                key={stack?.name}
                className="flex justify-center items-center flex-col gap-y-2"
              >
                <img
                  src={stack.src}
                  alt={stack.name}
                  className="sm:w-[70px] sm:h-[70px] w-[40px] h-[40px] hover:scale-125 duration-300"
                />
                <span className="font-light text-[12px] lg:text-[16px]">
                  {stack.name}
                </span>
              </div>
            );
          })}
        </div>

        <div className="stacks-marquee__group" aria-hidden="true">
          {stacks.map((stack) => {
            return (
              <div
                key={`${stack.name}-dup`}
                className="flex justify-center items-center flex-col gap-y-2"
              >
                <img
                  src={stack.src}
                  alt={stack.name}
                  className="sm:w-[70px] sm:h-[70px] w-[40px] h-[40px] hover:scale-125 duration-300"
                />
                <span className="font-light text-[12px] lg:text-[16px]">
                  {stack.name}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
